import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'signals-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit {
  @Output()
  onTimeChanged: EventEmitter<any> = new EventEmitter<any>();

  public value: number;
  public timePickerID: string;
  public hours = [];
  public minutes = [];
  @Input()
  public startTime: { min: string; hr: string } = { min: '00', hr: '00' };
  @Input()
  public endTime: { min: string; hr: string } = { min: '59', hr: '23' };
  private readonly debounceAndEmit: Subject<void> = new Subject<void>();

  ngOnInit() {
    this.evaluateTimeRange();
    this.generateRandomID();
    this.debounceAndEmit.pipe(debounceTime(100)).subscribe(() => {
      this.timeChanged();
    });
  }

  private evaluateTimeRange() {
    for (let i = 0; i <= 60; i++) {
      const toPush: string = (i < 10 ? '0' : '') + i;
      if (i < 24) {
        this.hours.push(toPush);
      }
      this.minutes.push(toPush);
    }
  }

  public timeChanged() {
    this.onTimeChanged.emit({
      startTime: this.startTime,
      endTime: this.endTime
    });
  }

  public clearDateTime() {
    this.startTime = { hr: '00', min: '00' };
    this.endTime = { hr: '23', min: '59' };
  }

  public startTimeChanged(selectedTime) {
    this.startTime = selectedTime;
    this.debounceAndEmit.next();
  }

  public endTimeChanged(selectedTime) {
    this.endTime = selectedTime;
    this.debounceAndEmit.next();
  }

  private generateRandomID() {
    this.timePickerID = '_' + Math.random().toString(36).substr(2, 9);
  }
}
